import script from "./StudentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentPage.vue?vue&type=style&index=0&id=333fef0e&lang=css"

const __exports__ = script;

export default __exports__